import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { Flex, Text } from '@bridebook/aura';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import AppBadge from '@bridebook/web/app-shared/components/app-badge/app-badge';

const SearchSuppliersApp = () => {
  const { t } = useTranslation('search');
  const isMobile = useSelector(getIsMobile);
  const market = useMarket();

  return (
    <Flex className="mb-20 h-[267px] justify-center gap-10 rounded-2xl bg-teal-20 px-10">
      <Flex className="flex-1 flex-col justify-center">
        <Text as="h2" className="mt-0 mb-2 text-2xl font-semibold">
          {t('signUp.title')}
        </Text>
        <Text className="text-space-75">{t('signUp.description')}</Text>
        <div className="mt-6">
          <AppBadge
            wrapperStyle={{
              '& > div': {
                flexDirection: 'row-reverse',
                gap: 16,
                justifyContent: 'flex-end',
              },
            }}
            market={market}
          />
        </div>
      </Flex>
      {!isMobile && (
        <img
          alt="app-signup"
          width={392}
          src="https://media.bridebook.com/assets/seo-pages/app-signup.webp"
        />
      )}
    </Flex>
  );
};

export default memo(SearchSuppliersApp);
